import { useEffect, useState } from "react";

export const useImageLoaded = (imageUrl: string | null | undefined) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    if (!imageUrl) {
      setIsImageLoaded(false);
      return;
    }

    setIsImageLoaded(false);
    const image = new Image();
    image.src = imageUrl;

    if (image.complete) {
      setIsImageLoaded(true);
      return;
    }

    const handleLoad = () => setIsImageLoaded(true);
    image.addEventListener("load", handleLoad, { once: true });

    return () => {
      image.removeEventListener("load", handleLoad);
    };
  }, [imageUrl]);

  return isImageLoaded;
};
